import * as React from 'react';
import { Divider } from '@awning/components';
import Heading from './Heading';
import EstimatedRevenue from './EstimatedRevenue';
import { PropertyManagement } from '@/src/PropertyManagement';
import { EstimatorListings } from './EstimatorListings';
import { EMapViewPage, EstimatorMarker, HomeMarker, MapView, useMapViewStore } from '@/src/MapView';
import { MapAndListingsContainerView } from './MapAndListingsContainer';
import { ListingEstimatorCardOverlayMarker } from '@/src/MapView/Markers/ListingEstimatorCardOverlayMarker';
import { EstimatorPagination } from '@/src/Pagination/EstimatorPagination';
import { maxListingCardWidth } from './EstimatorListings/Card';
import { MoreFilters } from '../Filters/Estimator/MoreFilters';
import { useEstimatorStore } from './store';
import { ComparableModal } from './EstimatorListings/ComparableModal';

export const Estimator = () => {
  return (
    <>
      <MapAndListingsContainerView
        maxWidth={maxListingCardWidth}
        renderListings={() => {
          return (
            <>
              <Heading />
              <EstimatedRevenue />
              <PropertyManagement />
              <Divider sx={{ height: 2, width: '100%', backgroundColor: 'gray.100' }} />
              <EstimatorListings />
              <EstimatorPagination />
              <ComparableModal isOpen={false} />
            </>
          );
        }}
        renderMapView={() => {
          return (
            <MapView page={EMapViewPage.ESTIMATOR} activeControls={['SELECT_VIEW_OPTION']}>
              <HomeMarker />
              <EstimatorMarker />
              <ListingEstimatorCardOverlayMarker />
              <SearchAreaCircle />
            </MapView>
          );
        }}
      />
      <MoreFilters />
    </>
  );
};

const SearchAreaCircle = () => {
  const map = useMapViewStore(state => state.map);
  const { listings, coordinates } = useEstimatorStore(state => ({
    listings: state.listings,
    coordinates: state.coordinates,
  }));

  const ref = React.useRef<undefined | google.maps.Circle>();

  React.useEffect(() => {
    if (ref.current) {
      ref.current.setMap(null);
    }
    if (map) {
      const radiusMiles = Math.max(...listings.map(l => l.radiusMiles));
      if (!ref.current) {
        ref.current = new google.maps.Circle({
          strokeColor: '#0066CC',
          strokeWeight: 2,
          fillColor: '#E6F2FF',
          fillOpacity: 0.25,
          center: new google.maps.LatLng(coordinates),
          radius: radiusMiles * 1609.34, // to meters
        });
      } else {
        ref.current.setCenter(new google.maps.LatLng(coordinates));
        ref.current.setRadius(radiusMiles * 1609.34);
      }
      ref.current.setMap(map);
    }
  }, [coordinates, listings, map]);
  return <div />;
};
